import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { hasRole, isHolding } from "@/js/http/auth.js";
export default {
  name: "ConsultantOrdersSubMenusLinks",
  data: function data() {
    return {
      selectedTab: null,
      tabs: {
        orders: "orders",
        sourcing: "sourcing",
        creditNote: "creditNote",
        inboundDeliveries: "inboundDeliveries",
        factoringProviders: "factoringProviders"
      }
    };
  },
  props: {
    loggedUserData: {
      type: Object,
      required: true
    },
    searchCriterias: {
      type: Object,
      required: false
    },
    isExternal: {
      type: Boolean,
      required: false,
      default: false
    },
    forceTab: {
      type: String,
      required: false,
      default: null
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.selectedTab = _this.$route.query.tab || _this.tabs.orders;
            if (_this.forceTab) {
              _this.selectedTab = _this.forceTab;
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    $route: function $route() {
      this.changeTab();
    }
  },
  methods: {
    changeTab: function changeTab() {
      if (this.forceTab) {
        this.selectedTab = this.forceTab;
      }
      if (this.isExternal) {
        this.$router.push({
          name: "adminOrderList",
          query: {
            tab: this.$route.query.tab
          },
          force: true
        }).catch(function () {});
      }
      if (this.$route.query.tab) {
        this.$emit("tabChanged", this.$route.query.tab);
        this.selectedTab = this.tabs[this.$route.query.tab];
      } else if (this.selectedTab) {
        this.$emit("tabChanged", this.selectedTab);
        this.selectedTab = this.tabs[this.selectedTab];
      } else {
        this.selectedTab = this.tabs.orders;
      }
    },
    isHolding: isHolding
  }
};